module.exports = __webpack_public_path__ + "img/login-img3.97c33577.png";